<template>
  <div>
    <b-modal
      centered
      v-model="showModal"
      id="gallery-modals"
      size="lg"
      scrollable
      :title="$t('property.roomImages')"
    >
      <div class="mt-5 p-3">
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333"
        >
          <b-carousel-slide
            v-for="url in media"
            :key="url"
            :img-src="url"
          ></b-carousel-slide>
        </b-carousel>
      </div>
      <template #modal-footer="{ cancel }">
        <button class="btn g-primary-button" @click="cancel()">
          {{ $t("property.closeGallery") }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "RoomDetails",
  data() {
    return {
      showModal: false,
      slide: 0,
      media: [],
    };
  },
  methods: {
    setMedia(media) {
      this.media = media;
    },
    show() {
      if (this.media.length) {
        this.slide = 0;
        this.showModal = true;
      }
    },
  },
};
</script>
